/**
 * @generated SignedSource<<25ff0c0ef79a8d61a6505e9a586f0a0d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContentModuleUtils_useCurriculumModuleIdsFragment$data = {
  readonly id: string;
  readonly modules: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly contentId: string;
        readonly id: string;
        readonly isReleased: boolean;
      };
    }>;
  };
  readonly " $fragmentType": "ContentModuleUtils_useCurriculumModuleIdsFragment";
};
export type ContentModuleUtils_useCurriculumModuleIdsFragment$key = {
  readonly " $data"?: ContentModuleUtils_useCurriculumModuleIdsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentModuleUtils_useCurriculumModuleIdsFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./ContentModuleUtils_useCurriculumModuleIdsRefetchQuery.graphql'),
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "ContentModuleUtils_useCurriculumModuleIdsFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentUsageNodeConnection",
      "kind": "LinkedField",
      "name": "modules",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ContentUsageNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ContentUsage",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isReleased",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "contentId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Curriculum",
  "abstractKey": null
};
})();

(node as any).hash = "754b85d98bbba26f4c3edb217a60ab2b";

export default node;
